<template>
  <div class="mine">
    <img class="bg" src="../assets/icon39.png" alt="">
    <div class="title">我的</div>
    <div class="info" @click="toSelf">
        <img v-if="res.head" class="infoimg" :src="res.head" alt="">
        <img v-else class="infoimg" src="../assets/icon42.png" alt="">
        <div class="infoDiv">
            <div>{{res.nickname}}</div>
            <img src="../assets/icon38.png" alt="">
        </div>
    </div>
    <div class="centerButton">
        <div style="border-bottom: 1px solid #ccc;margin: 1rem;">
            <div class="buttonLeft" @click="toInfo">
                <img src="../assets/icon41.png" alt="">
                <div>我的学生信息</div>
            </div>
            <img class="buttonRight" src="../assets/icon27.png" alt="">
        </div>
        <div style="margin: -1rem 1rem 0 1rem;">
            <div class="buttonLeft" @click="toRepassword">
                <img src="../assets/icon40.png" alt="">
                <div>修改密码</div>
            </div>
            <img class="buttonRight" src="../assets/icon27.png" alt="">
        </div>
    </div>
    <div class="out">
        <button @click="out">退出登录</button>
    </div>
    <sidebar :selected="select"></sidebar>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import http from '../utils/http'

export default {
  name: 'mine',
  components: { Sidebar },
  data () {
    return {
      select: 4,
      res: Object
    }
  },
  methods: {
    toInfo () {
      this.$router.push({name: 'studentsInfo'})
    },
    toRepassword () {
      this.$router.push({name: 'modification'})
    },
    toSelf () {
      this.$router.push({name: 'personal'})
    },
    out () {
      http['post']('auth/logout').finally(() => {
        localStorage.removeItem('token')
        this.$router.push({name: 'login'})
      })
    }
  },
  created () {
    http['get']('account').then((res) => { this.res = res })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg{
    position: relative;
    z-index: -1;
    width: 100%;
}
.title {
    position: absolute;
    top: 1rem;
    left: 50%;
    transform: translate(-50%, 0);
    color: #fff;
    font-size: 20px;
}
.info {
    position: absolute;
    top: 4rem;
    left: 1.5rem;
    display: flex;
    width: 90%;
}
.infoimg {
    height: 4rem;
    width: 4rem;
    border-radius: 50%;
}
.infoDiv {
    flex: 5;
    margin: 1.3rem 1rem;
    display: flex;
    justify-content: space-between;
}
.infoDiv div {
    color: #fff;
    font-size: 20px;
    height: 1.5rem;
    line-height: 1.5rem;
}
.infoDiv img {
    margin-top: 0.3rem;
    height: 1.5rem;
}
.centerButton {
    background: #fff;
    width: 90%;
    margin-top: -3.8rem;
    border-radius: 8px;
    margin-left: 1rem;
    box-shadow: 0 5px 5px rgba(0,0,0,.07);
}
.centerButton div {
    display: flex;
    justify-content: space-between;
}
.buttonLeft {
    margin: 1rem;
}
.buttonLeft img {
    width: 2rem;
    margin-right: 0.8rem;
}
.buttonLeft div {
    font-size: 18px;
    height: 2rem;
    line-height: 2rem;
}
.buttonRight {
    margin: 1.3rem;
    height: 1.5rem;
}
.out {
    position: absolute;
    bottom: 3.5rem;
    display: flex;
    justify-content: center;
    right: 0;
    left: 0;
}
.out button{
    width: 80%;
    height: 3.5rem;
    background: #ccc;
    border-radius: 44px;
    border: 0;
    margin-bottom: 1rem;
    color: #fff;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/mine/mine.vue